import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  loaded: false,
  loading: false,
  moduleLoading: false,
  moduleLoaded: false,
  roles: {},
  modules: {},
  error: null,
  moduleError: null
})

const { Types, Creators } = createActions({
  getAllRoles: null,
  getAllRolesSuccess: ['roles'],
  getAllRolesFailure: ['error'],

  getAllModules: null,
  getAllModulesSuccess: ['modules'],
  getAllModulesFailure: ['error'],

  trackUserRole: ['uid']
})

export const getAllRolesReducer = state =>
  state.set('loading', true).set('error', null)

export const getAllRolesSuccessReducer = (state, { roles }) =>
  state
    .set('roles', roles)
    .set('loading', false)
    .set('loaded', true)
    .set('error', null)

export const getAllRolesFailureReducer = (state, { error }) =>
  state
    .set('roles', {})
    .set('loading', false)
    .set('loaded', true)
    .set('error', error)

export const getAllModulesReducer = state =>
  state.set('moduleLoading', true).set('error', null)

export const getAllModulesSuccessReducer = (state, { modules }) =>
  state
    .set('modules', modules)
    .set('moduleLoading', false)
    .set('moduleLoaded', true)
    .set('moduleError', null)

export const getAllModulesFailureReducer = (state, { error }) =>
  state
    .set('modules', {})
    .set('moduleLoading', false)
    .set('moduleLoaded', true)
    .set('moduleError', error)

export const rolePermissionReducer = createReducer(INITIAL_STATE, {
  [Types.GET_ALL_ROLES]: getAllRolesReducer,
  [Types.GET_ALL_ROLES_SUCCESS]: getAllRolesSuccessReducer,
  [Types.GET_ALL_ROLES_FAILURE]: getAllRolesFailureReducer,

  [Types.GET_ALL_MODULES]: getAllModulesReducer,
  [Types.GET_ALL_MODULES_SUCCESS]: getAllModulesSuccessReducer,
  [Types.GET_ALL_MODULES_FAILURE]: getAllModulesFailureReducer
})

export const RolePermissionTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/rolePermissionReducer.js